/* This file is autogenerated, see readme.md for instructions */
import BoostSvgIcon from '@bloomreach/banana-theme/icons/boost.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const BoostIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <BoostSvgIcon />
    </Icon>
  );
});

BoostIcon.displayName = 'BoostIcon';

export default BoostIcon;
